<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{
        $t("viewCertificate.checkCertificate")
      }}</span>
    </p>
    <div class="main">
      <div class="form-layout">
        <el-form
          class="systemFont2 systemForm1"
          ref="newCertificateRef"
          :model="newCertificateForm"
          label-width="105px"
          hide-required-asterisk
        >
          <!-- 定义名称 -->
          <el-form-item
            :label="$t('certificateManagement.definitionName')"
            prop="definitionName"
            :rules="definitionName"
          >
            <el-input
              v-model="newCertificateForm.definitionName"
              size="reportContentInput"
              maxlength="125"
              :placeholder="$t('common.required')"
              :disabled="isdisabledName"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 定义模板 -->
          <el-form-item
            class="formItem"
            :label="$t('certificateManagement.definitiontemplate')"
            prop="templateId"
            :rules="templateId"
          >
            <div :class="isdisabled == true ? 'div-layout' : 'template-layout'">
              <div
                v-if="selectedTemplateFlag < 0"
                :class="
                  isdisabled == true ? 'upload-layout-disable' : 'upload-layout'
                "
                @click="dialogVisible = !isdisabled"
              >
                <i
                  class="el-icon-plus"
                  style="font-size: 28px; color: #8c939d; margin-top:35px;"
                ></i>
              </div>
              <div
                v-else
                :class="
                  isdisabled == true
                    ? 'img-selected-div-disable'
                    : 'img-selected-div'
                "
                @click="dialogVisible = !isdisabled"
              >
                <el-image
                  class="img-selected-layout"
                  :src="selectedTemplateImgUrl"
                  fit="fill"
                >
                </el-image>
              </div>
            </div>
            <el-input
              v-model="newCertificateForm.templateId"
              style="display: none"
            ></el-input>
            <el-dialog
              title=""
              :visible.sync="dialogVisible"
              width="600px"
              center
              :before-close="handleClose"
              :close-on-click-modal="false"
            >
              <el-row>
                <el-col
                  class="thumbnail-layout"
                  v-for="(item, index) in certificateData"
                  :key="index"
                  :span="8"
                  :offset="
                    certificateData.length == 1
                      ? 8
                      : certificateData.length == 2
                      ? index == 0
                        ? 2
                        : 4
                      : 0
                  "
                >
                  <el-tooltip
                    effect="dark"
                    :open-delay="800"
                    :disabled="!dialogVisible"
                    :content="$t('certificateManagement.clickAndDbClick')"
                    placement="bottom-start"
                  >
                    <div
                      class="img-div"
                      @click="selectTemplate(index)"
                      @dblclick="previewImg(index)"
                    >
                      <el-image
                        ref="templateImgRef"
                        class="img-layout"
                        :src="item.imagePath"
                        :preview-src-list="srcList[index]"
                        fit="fill"
                      >
                      </el-image>
                      <label
                        v-if="selectedTemplateFlag == index"
                        class="img-selected-label"
                      >
                        <i
                          class="el-icon-check"
                          style="color: #fff; transform: rotate(-90deg); transform-origin: 40% 75%;"
                        ></i>
                      </label>
                    </div>
                  </el-tooltip>
                </el-col>
              </el-row>
              <span slot="footer" class="dialog-footer">
                <el-button type="return" @click="cancelSelect">{{
                  $t("common.cancel")
                }}</el-button>
                <el-button
                  type="submit"
                  style="margin-left: 40px"
                  :disabled="selectedTemplateFlag < 0"
                  @click="confirmSelect"
                  >{{ $t("common.confirm") }}</el-button
                >
              </span>
            </el-dialog>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 关联课程 -->
          <el-form-item :label="$t('certificateManagement.relatedCourses')">
            <el-row
              v-for="(item, index) in newCertificateForm.relatedCoursesData"
              :key="index"
            >
              <el-form-item
                label-width="0px"
                :prop="`relatedCoursesData.${index}`"
                :rules="{
                  required: true,
                  validator: (rule, value, callback) => {
                    validateCourses(rule, index, value, callback);
                  },
                  trigger: 'change'
                }"
              >
                <el-select
                  filterable
                  v-model="newCertificateForm.relatedCoursesData[index]"
                  size="systemSelect3"
                  style="width: 100%"
                  placeholder=""
                  @change="courseChange(index)"
                  :disabled="isdisabled"
                >
                  <el-option
                    v-for="item in selection"
                    :key="item.field + item.category + item.courseNumber"
                    :label="
                      item.field +
                        item.category +
                        item.courseNumber +
                        '/' +
                        item.courseName
                    "
                    :value="
                      item.field +
                        item.category +
                        item.courseNumber +
                        '/' +
                        item.courseName
                    "
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 发证方式 -->
          <el-form-item
            :label="$t('certificateManagement.issuanceMethod')"
            prop="issuanceMethod"
            :rules="issuanceMethod"
          >
            <el-radio-group
              v-model="newCertificateForm.issuanceMethod"
              style="width: 100%; text-align: left"
              :disabled="isdisabled"
            >
              <el-col :span="11">
                <el-radio label="1">{{
                  $t("certificateManagement.aCourse")
                }}</el-radio>
              </el-col>
              <el-col :span="11" :offset="2">
                <el-radio label="2">{{
                  $t("certificateManagement.multipleCourses")
                }}</el-radio>
              </el-col>
            </el-radio-group>
          </el-form-item>
          <!-- 第三方证书上传 -->
          <el-form-item
            :label="$t('p0341.thirdPartyCertificateUpload')"
            prop="thirdPartyCert"
            :rules="thirdPartyCert"
          >
            <el-radio-group
              v-model="newCertificateForm.thirdPartyCert"
              style="width: 100%; text-align: left"
              :disabled="isdisabled"
            >
              <el-col :span="11">
                <!-- 允许 -->
                <el-radio label="1">{{ $t("p0341.allowed") }}</el-radio>
              </el-col>
              <el-col :span="11" :offset="2">
                <!-- 不允许 -->
                <el-radio label="2">{{ $t("p0341.notAllowed") }}</el-radio>
              </el-col>
            </el-radio-group>
          </el-form-item>
          <!--中英文版本-->
          <div :class="newCertificateForm.templateId === 7?'halfway':''">
            <el-tabs v-model="activeName" type="card">
              <!-- 中文版 -->
              <el-tab-pane :label="newCertificateForm.templateId === 7?'中文版':'证书内容'" name="first">
                <!-- 课程名称 -->
                <el-form-item
                  class="formItem formattedCourseNameClass"
                  :label="$t('courseOption.courseName')"
                  prop="certCourseName"
                >
                  <el-input
                    v-model="newCertificateForm.certCourseName"
                    class="formattedCourseNameClass"
                    type="textarea"
                    resize="none"
                    :disabled="isdisabled"
                    :rows="4"
                  ></el-input>
                </el-form-item>
                <div style="height: 17px;"></div>
                <!-- 课程证书描述 -->
                <el-form-item
                  class="formItem"
                  :label="$t('certificateManagement.courseCertificateDescription')"
                  prop="certDescription"
                >
                  <el-input
                    v-model="newCertificateForm.certDescription"
                    class="descriptionInput"
                    type="textarea"
                    resize="none"
                    :rows="6"
                    :disabled="isdisabled"
                  ></el-input>
                </el-form-item>
              </el-tab-pane>
              <!-- 英文版 -->
              <el-tab-pane label="英文版" v-if="newCertificateForm.templateId === 7" name="second">
                <!-- 课程名称 -->
                <el-form-item
                  class="formItem formattedCourseNameClass"
                  :label="$t('courseOption.courseName')"
                  prop="certCourseNameEn"
                >
                  <el-input
                    v-model="newCertificateForm.certCourseNameEn"
                    class="formattedCourseNameClass"
                    type="textarea"
                    resize="none"
                    :disabled="isdisabled"
                    :rows="4"
                  ></el-input>
                </el-form-item>
                <div style="height: 17px;"></div>
                <!-- 课程证书描述 -->
                <el-form-item
                  class="formItem"
                  :label="$t('certificateManagement.courseCertificateDescription')"
                  prop="certDescriptionEn"
                >
                  <el-input
                    v-model="newCertificateForm.certDescriptionEn"
                    class="descriptionInput"
                    type="textarea"
                    resize="none"
                    :disabled="isdisabled"
                    :rows="6"
                  ></el-input>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form>
      </div>
      <div class="icon-layout" v-show="show">
        <el-form
          class="systemFont2 systemForm1"
          :model="newCertificateForm"
          label-width="0px"
        >
          <el-form-item>
            <div
              v-for="(item, index) in newCertificateForm.relatedCoursesData"
              :key="index"
            >
              <div v-if="index == 0" class="add-icon-layout">
                <img class="icon" src="@/assets/add.svg" @click="add()" />
              </div>
              <div v-if="index != 0" class="subtract-icon-layout">
                <img
                  class="icon"
                  src="@/assets/subtract.svg"
                  @click="subtract(index)"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-row class="foot-container">
      <!-- 证书预览 -->
      <el-col :span="isdisabled == true ? 8 : 6">
        <el-button type="return" @click.native.prevent="certificatePreview">{{
          $t("p0341.certificatePreview")
        }}</el-button>
      </el-col>
      <!-- 编辑 -->
      <el-col :span="8">
        <el-button
          v-if="isdisabled"
          type="submit"
          @click.native.prevent="handleEdit"
          >{{ $t("common.edit") }}</el-button
        >
      </el-col>
      <!-- 保存 -->
      <el-col v-if="!isdisabled" :span="6">
        <el-button type="submit" @click.native.prevent="handleSave">{{
          $t("common.save")
        }}</el-button>
      </el-col>
      <!-- 删除 -->
      <el-col v-if="!isdisabled" :span="6">
        <el-button type="submit" @click="handleDelete">{{
          $t("common.delete")
        }}</el-button>
      </el-col>
      <el-col :span="isdisabled == true ? 8 : 6">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
      <!-- <el-dialog
        title=""
        width="400px"
        :visible.sync="deleteDialogVisible"
        :before-close="handleClose">
        <span style="font-size: 16px;">{{$t('viewCertificate.deleteInformation')}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="return" @click="deleteDialogVisible = false">{{$t('common.cancel')}}</el-button>
          <el-button type="submit" @click="handleDelete">{{$t('common.confirm')}}</el-button>
        </span>
      </el-dialog> -->
    </el-row>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      activeName: "first",
      // 表单数据
      newCertificateForm: {
        userId: "",
        definitionName: "",
        templateId: "",
        relatedCoursesData: [""],
        issuanceMethod: "",
        thirdPartyCert: "",
        certDescription: "",
        certCourseName: "",
        certCourseNameEn: "",
        certDescriptionEn: ""
      },
      // 旧的表单数据
      oldnewCertificateForm: {},
      // 证书数据
      certificateData: [],
      // 关联课程的选择项数据
      selection: [],
      // 对话框显示标志
      dialogVisible: false,
      // 选中模板标志
      selectedTemplateFlag: -1,
      // 选中的证书模板图片路径
      selectedTemplateImgUrl: "",
      // 旧的选中的证书模板图片路径
      oldselectedTemplateImgUrl: "",
      // 证书模板预览大图Url
      srcList: [],
      // 初始化超时
      timer: null,
      // 定义名称只读
      isdisabledName: true,
      // 各项目显示为只读
      isdisabled: true,
      // 添加删除按钮为只读
      show: false,
      // 删除对话框显示标志
      deleteDialogVisible: false,
      // 证书名称
      certificateName: JSON.parse(sessionStorage.getItem("p0342"))
        .definitionName,
      // 关联课程选择的校验规则
      validateCourses(rule, index, value, callback) {
        if (value) {
          for (
            let i = 0;
            i < this.newCertificateForm.relatedCoursesData.length;
            i++
          ) {
            if (
              i != index &&
              this.newCertificateForm.relatedCoursesData[i] != ""
            ) {
              if (this.newCertificateForm.relatedCoursesData[i] == value) {
                return callback(
                  new Error(
                    this.$t(
                      "certificateManagement.duplicateRelatedCourseExists"
                    )
                  )
                );
              }
            }
          }
        } else {
          return callback(
            new Error(
              this.$t("certificateManagement.pleaseSelectRelatedCourses")
            )
          );
        }
        callback();
      },
      // 校验规则
      definitionName: [
        {
          required: true,
          message: this.$t("certificateManagement.pleaseEnterDefinitionName"),
          trigger: "blur"
        }
      ],
      templateId: [
        {
          required: true,
          message: this.$t(
            "certificateManagement.pleaseSelectDefinitionTemplate"
          ),
          trigger: "change"
        }
      ],
      issuanceMethod: [
        {
          required: true,
          message: this.$t("certificateManagement.pleaseSelectIssuanceMethod"),
          trigger: "change"
        }
      ],
      thirdPartyCert: [
        {
          required: true,
          message: this.$t("p0341.selectThirdPartyUpload"),
          trigger: "change"
        }
      ],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 证书预览
    certificatePreview() {
      if (this.newCertificateForm.templateId == "") {
        return this.$message.error("未选择证书");
      }
      // 根据课程编号筛选课程名称写入表单
      if (
        this.newCertificateForm.relatedCoursesData != "" &&
        this.newCertificateForm.relatedCoursesData != null &&
        this.newCertificateForm.relatedCoursesData.length > 0
      ) {
        this.newCertificateForm.courseName = this.selection.filter(item => {
          return (
            item.field +
              item.category +
              item.courseNumber +
              "/" +
              item.courseName ===
            this.newCertificateForm.relatedCoursesData[
              this.newCertificateForm.relatedCoursesData.length - 1
            ]
          );
        })[0].courseName;
      } else {
        if (
          this.newCertificateForm.templateId !== 2 &&
          this.newCertificateForm.templateId !== 3
        ) {
          return this.$message.error("未选择关联课程");
        }
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/certificateManagement/certificatePreview";
      this.$http
        .post(url, this.newCertificateForm, { responseType: "blob" })
        .then(response => {
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            console.log("文件大小为0");
            loading.close();
          } else {
            let fileName = "证书预览.pdf";
            if (
              this.newCertificateForm.templateId == 2 ||
              this.newCertificateForm.templateId == 3
            ) {
              fileName = "证书预览.jpg";
            }

            if ("download" in document.createElement("a")) {
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
          }
          loading.close();
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 初始化
    initData() {
      let url = "/api/viewCertificate/initData";
      let p0342 = JSON.parse(sessionStorage.getItem("p0342"));
      this.$http
        .post(
          url,
          qs.stringify({
            certificateName: p0342.definitionName
          })
        )
        .then(response => {
          if (response.data.code === 200) {
            // 定义名称
            this.newCertificateForm.definitionName =
              response.data.data.definitionName;
            this.newCertificateForm.certCourseName =
              response.data.data.certCourseName;
            this.newCertificateForm.certCourseNameEn =
              response.data.data.certCourseNameEn;
            this.newCertificateForm.templateId = response.data.data.templateId;
            // console.log("response.data.data.imagePath",response.data.data.imagePath)
            this.selectedTemplateImgUrl = response.data.data.imagePath;
            // this.selectedTemplateFlag=(response.data.data.templateId)-2
            // console.log("selectedTemplateImgUrl",this.selectedTemplateImgUrl)
            // 发证方式
            this.newCertificateForm.issuanceMethod =
              response.data.data.issuanceMethod;
            // 第三方发证方式
            this.newCertificateForm.thirdPartyCert = response.data.data
              .thirdPartyCert
              ? response.data.data.thirdPartyCert
              : "2";
            this.newCertificateForm.relatedCoursesData =
              response.data.data.relatedCoursesData;
            this.newCertificateForm.certDescription =
              response.data.data.certDescription;
            this.newCertificateForm.certDescriptionEn =
              response.data.data.certDescriptionEn;

            // 关联课程选择项数据
            this.selection = response.data.data.lessonList;
            // 证书数据
            this.certificateData = response.data.data.certificateTemplateList;
            // 证书选择标志
            if (
              this.certificateData != null ||
              this.certificateData.length > 0
            ) {
              for (let i = 0; i < this.certificateData.length; i++) {
                if (
                  this.certificateData[i].templateId ==
                  response.data.data.templateId
                ) {
                  this.selectedTemplateFlag = i;
                  break;
                }
              }
            }
            // 证书模板预览大图Url
            this.certificateData.forEach(element => {
              this.srcList.push([element.imagePath]);
            });
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 选择证书模板（单击事件）
    selectTemplate(value) {
      // 阻止上一次setTimeout()方法执行函数
      clearTimeout(this.timer);
      var that = this;
      this.timer = setTimeout(function() {
        that.selectedTemplateFlag = value;
      }, 200);
    },
    // 预览证书的中英文模板（双击事件）
    previewImg(value) {
      // 阻止单击事件里的setTimeout()方法执行函数
      clearTimeout(this.timer);
      this.$refs.templateImgRef[value].clickHandler();
    },
    // 确认选择证书模板
    confirmSelect() {
      this.newCertificateForm.templateId = this.certificateData[
        this.selectedTemplateFlag
      ].templateId;
      this.selectedTemplateImgUrl = this.certificateData[
        this.selectedTemplateFlag
      ].imagePath;
      // 切换模板清空信息
      if (this.newCertificateForm.templateId !== 7) {
        this.activeName = "first"
      }
      this.dialogVisible = false;
    },
    // 取消选择证书模板
    cancelSelect() {
      if (this.newCertificateForm.templateId == "") {
        this.selectedTemplateFlag = -1;
      }
      this.dialogVisible = false;
    },
    // 关闭前的回调
    handleClose(done) {
      if (this.newCertificateForm.templateId == "") {
        this.selectedTemplateFlag = -1;
      }
      done();
    },
    // 关联课程改变选择项
    courseChange(param) {
      let that = this;
      this.newCertificateForm.relatedCoursesData.forEach(function(
        value,
        index,
        array
      ) {
        if (param != index && value != "" && value != null) {
          that.$refs.newCertificateRef.validateField(
            `relatedCoursesData.${index}`
          );
        }
      });
      // 根据课程编号筛选课程名称写入表单
      if (
        this.newCertificateForm.relatedCoursesData != "" &&
        this.newCertificateForm.relatedCoursesData != null &&
        this.newCertificateForm.relatedCoursesData.length > 0 &&
        param === 0
      ) {
        let courseName = this.selection.filter(item => {
          return (
            item.field +
              item.category +
              item.courseNumber +
              "/" +
              item.courseName ===
            this.newCertificateForm.relatedCoursesData[0]
          );
        })[0].courseName;
        this.$set(this.newCertificateForm, "certCourseName", courseName);
      }
    },
    // 新增关联课程
    add() {
      if (this.newCertificateForm.relatedCoursesData.length == 10) {
        return;
      }
      this.newCertificateForm.relatedCoursesData.push("");
    },
    // 删减关联课程
    subtract(index) {
      this.newCertificateForm.relatedCoursesData.splice(index, 1);
      let that = this;
      this.newCertificateForm.relatedCoursesData.forEach(function(
        value,
        index,
        array
      ) {
        if (value != "" && value != null) {
          that.$refs.newCertificateRef.validateField(
            `relatedCoursesData.${index}`
          );
        }
        if (value == "" || value == null) {
          that.$nextTick(function() {
            that.$refs.newCertificateRef.clearValidate([
              `relatedCoursesData.${index}`
            ]);
          });
        }
      });
    },
    isOldData() {
      this.oldnewCertificateForm = JSON.stringify(this.newCertificateForm);
      this.oldselectedTemplateImgUrl = this.selectedTemplateImgUrl;
    },
    // 编辑
    handleEdit() {
      this.isdisabled = false;
      this.show = true;
      this.isOldData();
    },
    isContentChanged() {
      if (
        this.oldnewCertificateForm ===
          JSON.stringify(this.newCertificateForm) &&
        this.oldselectedTemplateImgUrl === this.selectedTemplateImgUrl
      ) {
        this.$message({
          message: this.$t("common.contentIsUnchanged"),
          type: "warning"
        });
        return true;
      }
      return false;
    },
    // 请填写课程名称和课程证书描述
    validation(){
      let {
        certCourseName, certDescription,
        certCourseNameEn, certDescriptionEn
      } = this.newCertificateForm
      // 切换模板清空信息
      if (this.newCertificateForm.templateId !== 7) {
        certCourseNameEn = ""
        certDescriptionEn = ""
      }
      const isChineseGroupValid = !!certCourseName && !!certDescription
      // id为7 存在英文证书
      if (this.newCertificateForm.templateId === 7) {
        const isEnglishGroupValid = !!certCourseNameEn && !!certDescriptionEn
        if ((isChineseGroupValid && !certCourseNameEn && !certDescriptionEn) ||
          (isEnglishGroupValid && !certCourseName && !certDescription)||
          (isChineseGroupValid && isEnglishGroupValid)) {
          return true
        }
      } else {
        // 否则只验证中文
        if (isChineseGroupValid) {
          return true
        }
      }
      return false
    },
    // 保存
    handleSave() {
      if (this.isContentChanged()) {
        return;
      }
      this.$refs["newCertificateRef"].validate(valid => {
        if (valid) {
          // 请填写课程名称和课程证书描述
          if (!this.validation()){
            // 请填写课程名称和课程证书描述
            return this.$message.error(this.$t('p0341.msg1'))
          }
          // 切换模板清空信息
          if (this.newCertificateForm.templateId !== 7) {
            this.newCertificateForm.certCourseNameEn = ""
            this.newCertificateForm.certDescriptionEn = ""
          }
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/viewCertificate/save";
          this.newCertificateForm.userId = localStorage.getItem("userId");
          this.$http
            .post(url, this.newCertificateForm)
            .then(response => {
              if (response.data.code === 200) {
                // this.saveCourse(),
                // this.selectedTemplateFlag = 1
                // console.log("selectedTemplateImgUrl",this.selectedTemplateImgUrl)
                this.isdisabled = true;
                this.show = false;
                this.activeName = "first"
                loading.close();
                this.$message.success(response.data.data);
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 删除
    handleDelete() {
      // 确认删除证书信息？
      this.$confirm(this.$t("viewCertificate.deleteInformation"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          let url = "/api/viewCertificate/deleteCertificate";
          this.$http
            .post(
              url,
              qs.stringify({
                definitionName: this.newCertificateForm.definitionName
              })
            )
            .then(response => {
              if (response.data.code === 200) {
                // this.deleteCourse(),
                loading.close();
                this.$message.success(response.data.data);
                this.$router.push({
                  path: "/views/GreenJacketForum/P0342"
                });
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        })
        .catch(() => {});
    },
    // 返回
    handleReturn() {
      sessionStorage.setItem("detailReturn", true);
      this.$router.push({
        path: "/views/GreenJacketForum/P0342"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 600px;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}

.form-layout {
  width: 410px;
  margin-left: 60px;
}

.template-layout {
  height: 150px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 5px;
}
.div-layout {
  height: 150px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 5px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}
.upload-layout {
  height: 100px;
  width: 100px;
  margin: 25px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  background-color: rgb(251, 253, 255);
  cursor: pointer;
}
.upload-layout-disable {
  height: 100px;
  width: 100px;
  margin: 25px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  background-color: rgb(251, 253, 255);
  cursor: not-allowed;
}
.upload-layout:hover {
  border-color: rgb(64, 158, 255);
}

.img-selected-div {
  width: 90px;
  height: 120px;
  margin: 15px;
  cursor: pointer;
}
.img-selected-div-disable {
  width: 90px;
  height: 120px;
  margin: 15px;
  cursor: not-allowed;
}
.img-selected-layout {
  width: 90px;
  height: 120px;
}

.img-div {
  width: 150px;
  height: 200px;
  margin: 0 auto;
  cursor: pointer;
}

.thumbnail-layout {
  text-align: center;
  padding: 20px 0;
}

.img-layout {
  width: 150px;
  height: 200px;
  pointer-events: none;
}

.img-selected-label {
  position: absolute;
  width: 36px;
  height: 36px;
  background: #13ce66;
  text-align: center;
  line-height: 20px;
  transform: rotate(90deg);
  transform-origin: 0% 0%;
  clip-path: polygon(0% 0%, 100% 0%, 0% 100%);
}

// 图标的区域
.icon-layout {
  margin-top: 207px;
  width: 40px;
}

// 加号、减号图标的样式
.icon {
  float: left;
  cursor: pointer;
}

// 加号图标的区域
.add-icon-layout {
  height: 14px;
  padding: 13px;
}

// 减号图标的区域
.subtract-icon-layout {
  height: 4px;
  padding: 18px 12px;
}

.foot-container {
  margin: 50px auto 0 auto;
  height: 26px;
  width: 24%;
  text-align: center;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}

// el-form-item的error提示信息位置
.formItem >>> .el-form-item__error {
  padding-top: 38px;
}
.formattedCourseNameClass >>> .el-form-item__error {
  padding-top: 28px;
}
.formattedCourseNameClass >>> .el-textarea__inner {
  text-align: right !important;
}
>>> .el-tabs--card>.el-tabs__header{
  margin-bottom: 1px;
  border: none;
}
>>> .el-tabs__header .is-top{
  width: 100%;
}
.halfway >>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  width: 50%!important;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
  width: 100%;
  padding-left: 60px;
  padding-right: 60px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-color: #f2f2f2;
  background-color: rgb(246, 246, 246);
  color: #333;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  font-weight: 700;
  font-style: normal;
  color: #7f7f7f;
}
>>> .el-tabs__content{
  border: 1px solid #ccc;
  border-radius: 0 0 5px 5px;
  padding: 10px;
}
>>> .el-tabs__item.is-disabled{
  cursor: no-drop;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0343.vue